import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Student } from 'src/app/models/student';
import { StudentsService } from 'src/app/services/students/students.service';
import { FormsModule } from '@angular/forms';
import { StudentListComponent } from '../student-list/student-list.component';

@Component({
  selector: 'li-student-edit',
  templateUrl: './student-edit.component.html',
  styleUrls: ['./student-edit.component.scss'],
  standalone: true,
  imports: [FormsModule]
})
export class StudentEditComponent implements OnInit {
  @Input()
  public student?: Student = undefined;

  @Input()
  public simple: boolean = false;

  @Output()
  public closing = new EventEmitter<Student>();

  public genders = [
    { id: 0, text: 'Männlich' },
    { id: 1, text: 'Weiblich' },
    { id: 2, text: 'Divers' },
  ];

  public get model(): Student {
    return this.student || <Student>{};
  }

  constructor(private studentsService: StudentsService) {}

  ngOnInit(): void {}

  public close(): void {
    this.closing.emit();
  }

  public save(): void {
    if (!this.student) {
      this.closing.emit();
      return;
    }

    const student = this.sanitize(this.model);

    this.studentsService
      .set(student)
      .subscribe(response => {
        student.sid = response.sid;
        this.closing.emit(student);
      });
  }

  public visibility(): string {
    return this.student ? 'show' : 'hidden';
  }

  private sanitize(student: Student): Student {
    if (student) {
      student.firstname ??= '';
      student.lastname ??= '';
      student.gender ??= 0;
      student.street ??= '';
      student.house ??= 0;
      student.house_suffix ??= '';
      student.zip ??= '';
      student.city ??= '';
      student.phone ??= '';
      student.email ??= '';
    }

    return student;
  }
}
